module.exports = require("substance/dist/substance");


//////////////////
// WEBPACK FOOTER
// external "substance/dist/substance"
// module id = 0
// module chunks = 0